import { render, staticRenderFns } from "./VideoEditModel.vue?vue&type=template&id=aa135816&"
import script from "./VideoEditModel.vue?vue&type=script&lang=js&"
export * from "./VideoEditModel.vue?vue&type=script&lang=js&"
import style0 from "./VideoEditModel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports